import { getTimezoneOffset } from 'date-fns-tz';

export const getOverrideTime = (timezone: string): string => {
  const offsetHours = getTimezoneOffset(timezone) / (1000 * 60 * 60);
  const hours = 12 + Math.round(offsetHours);
  return `${String(hours).padStart(2, '0')}:00`;
};
